import { StyleSheet, Text, View, Image } from 'react-native'
import React from 'react'
import { globalStyles } from '../../../static/styles/global'
import Card from '../../../components/shared/card/Card'
import { boardStyles } from '../../../static/styles/board'

const WelcomeSecond = () => {
  return (
    <>
      {/* <Text
        style={{
          fontWeight: 'bold',
          fontSize: 27,
          color: 'white',
          alignSelf: 'center'
        }}
      >
        On Boarding
      </Text>

      <Text
        style={{
          fontSize: 17,
          color: 'white',
          alignSelf: 'center',
          marginTop: '5%'
        }}
      >
        We’ll walk you through the essential{' '}
      </Text>
      <Text style={{ fontSize: 17, color: 'white', alignSelf: 'center' }}>
        paperwork to complete get you started
      </Text>
      <Text style={{ fontSize: 17, color: 'white', alignSelf: 'center' }}>
        and earning your first paycheck.
      </Text> */}

      {/* <View style={[styles.rectangle]}> */}

      <Image
        source={require('../../../static/images/Welcome-Login.png')}
        style={[styles.appBrand]}
        resizeMode="contain"
      />
      {/* </View> */}
    </>
  )
}

export default WelcomeSecond

const styles = StyleSheet.create({
  rectangle: {
    alignSelf: 'center',
    marginTop: '20%',
    width: '30%',
    height: '64%',
    // backgroundColor: 'white',
    borderRadius: 15
  },
  appBrand: {
    width: '50%',
    height: '70%',
    alignSelf: 'center'
    // marginTop:'10%'
  }
})
